// @ts-nocheck


import React, { useCallback, useState } from 'react';
import Button from 'antd/lib/button';

import { Wrapper } from './styles';
import Grid, { GridItem } from '../../../../../../components/layout/Grid';
import { Checkbox, Footer } from './styles';














export const Filters = ({ expanded, onClean, onChange }) => {
  const [filters, setFilters] = useState({});

  const handleChange = (key) => (
  value) =>
  {
    const copy = { ...filters };
    copy[key] = value.target.checked;
    onChange(copy);
    setFilters(copy);
  };

  const handleClean = useCallback(() => {
    onClean();
    setFilters({});
  }, [onClean]);

  return (
    <Wrapper expanded={expanded}>
      <Grid>
        <GridItem>
          <Checkbox checked={filters.moving} onChange={handleChange('moving')}>
            Движется
          </Checkbox>
        </GridItem>
        <GridItem>
          <Checkbox
            checked={filters.connected}
            onChange={handleChange('connected')}>

            На связи
          </Checkbox>
        </GridItem>
        <GridItem>
          <Checkbox
            checked={filters.stopped}
            onChange={handleChange('stopped')}>

            Стоит
          </Checkbox>
        </GridItem>
        <GridItem>
          <Checkbox
            checked={filters.disconnected}
            onChange={handleChange('disconnected')}>

            Не на связи
          </Checkbox>
        </GridItem>
      </Grid>
      <Footer>
        <Button type="primary" size="small" onClick={handleClean}>
          Очистить
        </Button>
      </Footer>
    </Wrapper>);

};
